"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFields = void 0;
function FormFields({ children, formikProps, }) {
    return children ? ("function" === typeof children ? children(formikProps) : children) : undefined;
}
exports.FormFields = FormFields;
//# sourceMappingURL=FormFields.js.map